import {
  actionTypes,
  delegationRequestSuccess,
  delegationRequestFailure,
  deleteDelegationRequestSuccess,
  deleteDelegationRequestFailure,
  modifyDelegationRequestSuccess,
  modifyDelegationRequestFailure,
  delegationUserRequestSuccess,
  delegationUserRequestFailure,
  delegationUserBAORequestSuccess,
  delegationUserBAORequestFailure,
  createDelegationRequestSuccess,
  createDelegationRequestFailure,
  delegationRequest,
} from "./actions";
import {
  fetchDelegationRequest,
  fecthDelegableUserRequest,
  fecthDelegableUserBAORequest,
  fetchDeleteDelegationRequest,
  fetchCreateDelegation,
  fetchModifyDelegation,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchDelegationRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELEGATION_REQUEST),
    mergeMap(() =>
      fetchDelegationRequest().pipe(
        map((response: any) => delegationRequestSuccess(response)),
        catchError((error: any) => of(delegationRequestFailure(error)))
      )
    )
  );

const fetchDeleteDelegationRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_DELEGATION_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteDelegationRequest(action.id).pipe(
        mergeMap((response: any) => {
          return of(
            delegationRequest(),
            deleteDelegationRequestSuccess(response)
          );
        }),
        catchError((error: any) => of(deleteDelegationRequestFailure(error)))
      )
    )
  );

const fetchModifyDelegationRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.MODIFY_DELEGATION_REQUEST),
    mergeMap((action: any) =>
      fetchModifyDelegation(action.id, action.modifyDate).pipe(
        mergeMap((response: any) => {
          return of(
            delegationRequest(),
            modifyDelegationRequestSuccess(response)
          );
        }),

        catchError((error: any) => of(modifyDelegationRequestFailure(error)))
      )
    )
  );

const fetchDelegationUserRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELEGATION_USER_REQUEST),
    mergeMap(() =>
      fecthDelegableUserRequest().pipe(
        map((response: any) => delegationUserRequestSuccess(response)),
        catchError((error: any) => of(delegationUserRequestFailure(error)))
      )
    )
  );

const fetchDelegationUserBAORequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELEGATION_USER_BAO_REQUEST),
    mergeMap((action: any) => {
      return fecthDelegableUserBAORequest(action.ou).pipe(
        map((response: any) => delegationUserBAORequestSuccess(response)),
        catchError((error: any) => of(delegationUserBAORequestFailure(error)))
      );
    })
  );

const fetchCreateDelegationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_DELEGATION),
    mergeMap((action: any) =>
      fetchCreateDelegation(action.delegationOBJ).pipe(
        map((response: any) => createDelegationRequestSuccess(response)),
        catchError((error: any) => of(createDelegationRequestFailure(error)))
      )
    )
  );

export default [
  fetchDelegationRequestsEpic,
  fetchDeleteDelegationRequestEpic,
  fetchModifyDelegationRequestEpic,
  fetchDelegationUserRequestEpic,
  fetchDelegationUserBAORequestEpic,
  fetchCreateDelegationEpic,
];
